import React, { ReactChild } from "react"
import styled from "styled-components"
import { Spinner } from "react-bootstrap"

interface Props {
  isOverlay?: Boolean
  message?: String
  color?: "green" | "red" | "blue"
  size?: number
  className?: string
  children?: ReactChild | ReactChild[]
}

export default function AcLoading(props: Props) {
  const { isOverlay, message, color = "blue", size = 40, className = "", children } = props

  const colors = {
    green: "#11bc4c",
    red: "#f00",
    blue: "#0d6efd",
  }
  return (
    <Overlay isOverlay={isOverlay} className={className}>
      <div className={"loader"}>{children}</div>
      <Message isOverlay={isOverlay}>
        <ProcessingSpinner animation={"border"} color={colors[color] || color} size={size} />
        <span>{message === null || message === undefined ? "ただいま処理中です、しばらくお待ちください。" : message}</span>
      </Message>
    </Overlay>
  )
}
//
const Message = styled.div`
  font-size: 1.4rem;
  color: #222222;
  ${(props) => props.isOverlay && "color: #fff;top: 50%;left: 50%;"}
  display: block;
  position: fixed;
  transform: translate(-50%, -50%);
  -webkit-transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
  display: flex;
  align-items: center;
  justify-content: center;
  width: auto;

  @media screen and (max-width: 414px) {
    font-size: 1rem;
    width: 90%;
  }
`

const ProcessingSpinner = styled(Spinner)`
  ${(props) => `color:${props.color};`}
  ${(props) => `min-width:${props.size}px;min-height:${props.size}px;`}
  margin-right: 30px;
`
const Overlay = styled.div`
  ${(props) =>
    props.isOverlay &&
    `
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    background-color: #000000bf;
    position: absolute;
    z-index: 10000;
`}
`
